(function () {
  'use strict';

  // Codes et libellés dans la langue de la page : bloc JSON [data-rolex-country-data] rendu par country-rolex-tool.liquid
  // depuis le snippet rolex-country-codes (source unique, partagée avec le tableau) et les clés sections.rolex_country.*.
  // Chaque code : { a: astérisqué ?, m: [{ p: pays, n: note éventuelle }, …] } (plusieurs marchés selon les époques si m > 1).
  function readData(root) {
    var el = root.querySelector('[data-rolex-country-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function normalizeInput(raw) {
    if (!raw) return null;
    var clean = String(raw).trim().toUpperCase();
    // Retirer astérisques et espaces internes
    clean = clean.replace(/[\*\s]/g, '');
    // Retirer "LC" si l'utilisateur l'a tapé devant
    clean = clean.replace(/^LC[:\-\s]*/, '');
    // Conserver seulement les chiffres
    if (!/^\d+$/.test(clean)) return null;
    if (clean.length < 2 || clean.length > 4) return null;
    // Pad à 3 chiffres
    while (clean.length < 3) clean = '0' + clean;
    if (clean.length > 3) return null;
    return clean;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderMarket(m) {
    var s = '<strong>' + escapeHtml(m.p) + '</strong>';
    if (m.n) s += ' <em>(' + escapeHtml(m.n) + ')</em>';
    return s;
  }

  function renderResult(code, entry, root, t) {
    var sellLabel = root.dataset.ctaSellLabel;
    var sellUrl = root.dataset.ctaSellUrl;
    var browseLabel = root.dataset.ctaBrowseLabel;
    var browseUrl = root.dataset.ctaBrowseUrl;

    var displayCode = code;
    if (entry.a) displayCode += '*';

    var html = '<div class="rolex-serial__result">';
    html += '<div class="rolex-serial__result-code">' + escapeHtml(t.code) + ' <strong>' + escapeHtml(displayCode) + '</strong></div>';
    html += '<div class="rolex-serial__result-country">';
    html += entry.m.map(renderMarket).join(' &nbsp;<span aria-hidden="true">/</span>&nbsp; ');
    html += '</div>';
    if (entry.m.length > 1) {
      html += '<p class="rolex-serial__result-note">' + t.multi_note + '</p>';
    } else if (entry.a) {
      html += '<p class="rolex-serial__result-note">' + t.asterisk_note + '</p>';
    }

    if ((sellLabel && sellUrl) || (browseLabel && browseUrl)) {
      html += '<div class="rolex-serial__ctas">';
      if (sellLabel && sellUrl) html += '<a href="' + escapeHtml(sellUrl) + '" class="btn btn--primary">' + escapeHtml(sellLabel) + '</a>';
      if (browseLabel && browseUrl) html += '<a href="' + escapeHtml(browseUrl) + '" class="btn btn--secondary">' + escapeHtml(browseLabel) + '</a>';
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  function renderNotFound(code, t) {
    return (
      '<div class="rolex-serial__result rolex-serial__result--not-found">' +
        '<div class="rolex-serial__result-code">' + t.not_listed.replace('__code__', escapeHtml(code || '?')) + '</div>' +
        '<p class="rolex-serial__result-note">' + t.not_listed_note + '</p>' +
      '</div>'
    );
  }

  function renderInvalid(t) {
    return (
      '<div class="rolex-serial__result rolex-serial__result--not-found">' +
        '<p class="rolex-serial__result-note">' + t.invalid + '</p>' +
      '</div>'
    );
  }

  function init(root) {
    var form = root.querySelector('[data-rolex-country-form]');
    var input = root.querySelector('[data-rolex-country-input]');
    var output = root.querySelector('[data-rolex-country-output]');
    var data = readData(root);
    if (!form || !input || !output || !data) return;
    var t = data.i18n;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var raw = input.value;
      var code = normalizeInput(raw);
      if (!code) {
        output.innerHTML = renderInvalid(t);
        return;
      }
      var entry = data.codes[code];
      if (entry) {
        output.innerHTML = renderResult(code, entry, root, t);
      } else {
        output.innerHTML = renderNotFound(code, t);
      }
    });
  }

  function bootAll() {
    var roots = document.querySelectorAll('[data-rolex-country-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
